export const fetchNotificationsAPI = "/notifications";
export function readNotificationAPI(id){ return "/notifications/"+id+"/read";}
export const markNotificationsAsReadAPI = "/mark-notifications-as-read";